module.exports = __webpack_public_path__ + "static/media/CTLI_9-111w.22d6426c.jpg";